export default __webpack_public_path__ + "static/media/photo--lg--131.06600723.jpg";